import { Dispatch } from "redux";
import { RelatorioActions } from "../store/ducks/relatorios";
import { sendErrorSentryOrLocalHost } from "../utils/funcs";
import { apiFetch } from "./httpClient";

export const getPainQuestionnaire = async (
	token: string,
	patientId: number | string | undefined,
	language: string,
	dispatch: Dispatch,
	signal?: AbortSignal
) => {
	try {
		const response = await apiFetch(
			`${process.env.REACT_APP_BASE_URL_V7}syncs/questionarios`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
				},
				body: JSON.stringify({
					TOKEN: token,
					ID_USUARIO: patientId,
					txAssincrono: "N",
					txIdioma: language?.toLowerCase?.(),
					txTipo: "EVA",
				}),
				signal,
			}
		);
		const data = await response.json();
		if (signal?.aborted) return undefined;
		dispatch(RelatorioActions.setQuestionnairePainEVA(data?.questionario));
		return data?.questionario;
	} catch (error) {
		if (signal?.aborted) return undefined;
		sendErrorSentryOrLocalHost(error, {
			message: "Erro ao buscar questionário de dor - getPainQuestionnaire",
			tags: {
				endpoint: "/syncs/questionarios",
				file: "src/services/painQuestionnaire.ts",
			},
		});
		return undefined;
	}
};
